import logoBrand from '@/assets/images/logo_basciano.svg'
import { Button } from '@/components/atoms/Button/Button'
import { LanguageSelector } from '@/components/molecules/LanguageSelector/LanguageSelector'
import { Logo } from '@/components/molecules/Logo/Logo'
import { useTranslation } from 'react-i18next'

interface MenuMobileProps {
  closeModal: () => void
}

export function MenuMobile ({ closeModal }: MenuMobileProps): JSX.Element {
  const { t } = useTranslation()

  // Función para manejar el scroll al hacer clic en los enlaces
  const handleScroll = (sectionId: string): void => {
    const section = document.getElementById(sectionId)
    if (section != null) {
      section.scrollIntoView({ behavior: 'smooth' })
    }

    closeModal()
  }

  return (
    <header className='w-full min-w-full min-h-screen'>
      <div className='pt-6 pl-4'>
        <Logo
          src={logoBrand}
          alt='Basciano Trading Logo'
          width={200}
          height={80}
        />
      </div>
      <ul className='flex flex-col items-start gap-4 mt-4 p-8'>
        <li>
          <button
            onClick={() => handleScroll('home')}
            className='text-primary hover:text-secondary font-bold'
          >
            {t('header.home')}
          </button>
        </li>
        <li>
          <button
            onClick={() => handleScroll('aboutUs')}
            className='text-primary hover:text-secondary font-bold'
          >
            {t('header.about')}
          </button>
        </li>
        <li>
          <button
            onClick={() => handleScroll('services')}
            className='text-primary hover:text-secondary font-bold'
          >
            {t('header.services')}
          </button>
        </li>
        <li>
          <button
            onClick={() => handleScroll('formContactUs')}
            className='text-primary hover:text-secondary font-bold'
          >
            {t('header.contact')}
          </button>
        </li>
        <Button className='w-full'>{t('header.login')}</Button>
        <LanguageSelector />
      </ul>
    </header>
  )
}
